import React, { useState } from "react"
import { FaPen } from "react-icons/fa"
import styled from "styled-components"
import { ProfileImage } from "@prosolve/common-components-ui"
import AccountImageModal from "./AccountImageModal"

const Container = styled.div`
  position: relative;
`

const Edit = styled(FaPen)`
  position: absolute;
  bottom: 8px;
  right: -6px;
  background: ${({theme}) => theme.backgrounds.pure};
  box-shadow: ${({theme}) => theme.boxShadow.main};
  border: ${({theme}) => theme.borders};
  border-radius: ${({theme}) => theme.borderRadius.main};
  color: ${({theme}) => theme.colors.primary};
  padding: 6px;
  cursor: pointer;
  font-size: 18px;
`

export default ({
  me,
  userAccount,
  onUpdate
}) => {
  const [isOpen, setIsOpen] = useState()

  const handleClose = async ({ update }) => {
    setIsOpen(false)
    if (update) {
      await onUpdate()
    }
  }

  return (
    <Container>
      <ProfileImage
        me={me}
        profile={userAccount}
        style={{ height: '140px', width: '140px' }}
      />
      <Edit onClick={() => setIsOpen(true)} />
      {isOpen &&
        <AccountImageModal userAccount={userAccount} onClose={handleClose} />
      }
    </Container>
  )
}
